/**
 * label-> string = Nome do botão
 * color-> string = Cor de fundo do botão
 * width-> sring = Largura do botão
 * textColor-> string = Cor do label do botão
 * type-> string = Tipo do botão
 * iconName -> string =  Imagem dentro da pasta icons
 * className -> string = custom className
 * _function -> fucntion = função de retorno
 * disabled -> bool = desabilitar botão
 */ 

import getImage from '../../useFull/getImage';
import './Btn.css';

const Btn = (props) => {

    const { label, color, width, textColor, type, iconName, className, _function, disabled, isSelected } = props
    const _className = `btn ${type === 'outline' ? 'btn-outline' : type === 'link' ? 'btn-link' : type === 'custom-outline' ? 'btn-custom-outline' : ''} ${disabled && 'btn-disabled'}`

    const img = getImage('icons', type === 'link' && !iconName ? 'arrow-right-primary300.png' : iconName);

    return (
        <section className={`container-customer ${className}`}>
            <div className={`container-customer-area ${!disabled && 'customer-area-enabled'}`} >
                <button
                    className={`${_className} ${isSelected === true ? 'btn-selected' : ''}`}
                    onClick={() => _function && !disabled && _function()}
                    disabled={disabled}
                    style={{
                        ...(color ?
                            {
                                backgroundColor: !type && color,
                            } : {}),
                        ...(type === 'outline' ? {
                            borderColor: type === 'outline' ? color : 'unset'
                        } : {}),
                        ...(width ? { width } : {}),
                        ...(textColor ? { color: textColor } : {})
                    }}>
                    <span>{label}</span>
                    {img && <img className={`container-customer-button-icon`} src={img} alt="Icone do botão" />}</button>
            </div>
        </section>
    )
}

export default Btn;